import React from 'react';
import {StatusSelectValueProps} from '../../Filters/StatusSelect';
import {SelectedStormModeStatusType} from '../../Filters/utils';
import StatusSelectMonitoring from "./StatusSelectMonitoring";

// TODO: сделать общими с подсказками в иконках
export const STORM_MODE_STATUS = Object.freeze({
    1: 'Штатный режим',
    2: 'Штормовой режим',
    unknown: 'Режим: Неизвестно',
});

export function StormModeStatusSelectMonitoring(props: StatusSelectValueProps<SelectedStormModeStatusType>) {
    return (
        <StatusSelectMonitoring
            {...props}
            statusDescription={STORM_MODE_STATUS}
            allValuesLabel="Все режимы"
        />
    );
}
export default StormModeStatusSelectMonitoring;
